(function () {

    'use strict';

    module.exports = {
        videoCallService: require('./services/video-call.service')
    }

})();
